import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function WritingModule({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-5.5 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <g strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.04315385 23.2778542v-4.4098736L23.2506538 5.89172889V1.03463281H7.83065385v6.70720246H1.02353846L1.00392308 27.4479623H23.2506538V14.7120431l-8.7190384 8.5658111z" />
          <path d="M7.83042308 1.03451945L1.02330769 7.74172191h6.80711539z" />
        </g>
        <path d="M4.78356934 27.5161133V30.875H26.7177734V11.385437" />
        <path d="M23.3157885 5.89569664l-.0426923.04137799 4.4538461 4.37643119.0426923-.04194482z" />
        <path d="M29.9520769 6.53728225l-2.8003846-2.75191988c-.4673077-.45855885-1.2213461-.45855885-1.6880769 0l-2.1478846 2.11027759 4.4538461 4.37586436-.0421154.04194482.0340385.0340093 2.1905769-2.1522224c.4667308-.45855885.4667308-1.19939495 0-1.65795379zM23.2732115 5.93724468l.0426923-.04137799-.0657692-.00396775L10.04321154 18.8675838v4.4104405h4.48846156l8.7184615-8.566378 4.4769231-4.39797044z" />
      </g>
    </svg>
  )
}

WritingModule.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
